import { atom } from 'jotai';

/**
 * Jotai atom to store the payment popup open state.
 * This allows sharing the popup state across different components
 * without prop drilling.
 */
export const paymentPopupOpenAtom = atom<boolean>(false);

/**
 * Jotai atom to store the current invoice UUID for payment.
 * This allows sharing the UUID across different components
 * without prop drilling.
 */
export const paymentPopupUuidAtom = atom<string>('');

/**
 * Jotai atom to store the Stripe account for payment.
 * This allows sharing the Stripe account across different components
 * without prop drilling.
 */
export const paymentPopupStripeAccountAtom = atom<string | null>(null);

/**
 * Jotai atom to store the invoice payment ID for payment.
 * This allows sharing the payment ID across different components
 * without prop drilling.
 */
export const paymentPopupPaymentIdAtom = atom<number>(0);
